import { getTracking } from 'ts-tracking-number';

export const getTrackingUrl = (trackingNumber?: string): string | null => {
  if (!trackingNumber) return null;
  const tracking = getTracking(trackingNumber);
  if (!tracking?.trackingUrl) return null;
  return tracking.trackingUrl.replace('%s', tracking.trackingNumber);
};

/** Amazon's public tracking site for multi-channel fulfillment shipments (TBA numbers). */
export const getAmazonTrackingUrl = (trackingNumber: string): string =>
  `https://www.swiship.com/track?id=${encodeURIComponent(trackingNumber)}`;
